import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M13.702 9.36525V5.80775C13.702 5.71792 13.6732 5.64417 13.6155 5.5865C13.5577 5.52883 13.4839 5.5 13.3943 5.5H3.80775C3.71792 5.5 3.64417 5.52883 3.5865 5.5865C3.52883 5.64417 3.5 5.71792 3.5 5.80775V19.1923C3.5 19.2821 3.52883 19.3558 3.5865 19.4135C3.64417 19.4712 3.71792 19.5 3.80775 19.5H13.3943C13.4839 19.5 13.5577 19.4712 13.6155 19.4135C13.6732 19.3558 13.702 19.2821 13.702 19.1923V15.6348H15.202V19.1923C15.202 19.6909 15.0253 20.1169 14.672 20.4703C14.3188 20.8234 13.8929 21 13.3943 21H3.80775C3.30908 21 2.88308 20.8234 2.52975 20.4703C2.17658 20.1169 2 19.6909 2 19.1923V5.80775C2 5.30908 2.17658 4.88308 2.52975 4.52975C2.88308 4.17658 3.30908 4 3.80775 4H13.3943C13.8929 4 14.3188 4.17658 14.672 4.52975C15.0253 4.88308 15.202 5.30908 15.202 5.80775V9.36525H13.702Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.96527 11.75L21.7595 11.75V13.25L9.96527 13.25L11.7845 15.0692L10.7308 16.1537L7.07702 12.5L10.7308 8.84625L11.7845 9.93075L9.96527 11.75Z",
		fill: "currentColor"
	})]
});
export default SvgEnter;
